import React from 'react';
import ComingSoonPage from '../components/ComingSoonPage';
import { useAuth } from '../contexts/AuthContext';

export default function Marche() {
  const { utilisateur, estConnecte } = useAuth();

  // Auth-aware CTA routing:
  //   - Logged out                  → /inscription (create an account)
  //   - Logged in WITHOUT arms_seller → /my-profile (add the role from "Mes rôles actifs")
  //   - Logged in WITH arms_seller    → /my-profile (manage existing seller profile)
  const isArmsSeller =
    utilisateur?.user_type === 'arms_seller' ||
    (utilisateur?.roles || []).some((r) => r.role === 'arms_seller' && r.active !== false);

  let ctaLink;
  let ctaLabel;
  if (!estConnecte) {
    ctaLink = '/signup';
    ctaLabel = { fr: 'Devenir vendeur', en: 'Become a vendor' };
  } else if (isArmsSeller) {
    ctaLink = '/my-profile';
    ctaLabel = { fr: 'Gérer mon profil vendeur', en: 'Manage my vendor profile' };
  } else {
    ctaLink = '/my-profile';
    ctaLabel = { fr: 'Ajouter le rôle Vendeur', en: 'Add the Vendor role' };
  }

  return (
    <ComingSoonPage
      title={{
        fr: 'Marketplace ChasseHunt',
        en: 'ChasseHunt Marketplace',
      }}
      sousTitre={{
        fr: 'Bientôt accessible',
        en: 'Coming soon',
      }}
      description={{
        fr: "Équipement de chasse, armes à feu et vêtements techniques. Tous nos vendeurs d'armes sont vérifiés selon les exigences PCAF (Programme canadien des armes à feu, GRC).",
        en: 'Hunting gear, firearms and technical clothing. All our firearms vendors are verified per Canadian Firearms Program (RCMP) requirements.',
      }}
      cartes={[
        {
          icon: '🔫',
          title: { fr: 'Armes à feu — vendeurs vérifiés', en: 'Firearms — verified vendors' },
          description: {
            fr: "Chaque vendeur d'armes fournit son permis PPA valide avant inscription sur la plateforme.",
            en: 'Each firearms vendor provides their valid PAL before registering on the platform.',
          },
        },
        {
          icon: '🎒',
          title: { fr: 'Équipement neuf et usagé', en: 'New and used gear' },
          description: {
            fr: 'Munitions, vêtements de camouflage, optique, accessoires de terrain, sacs à dos.',
            en: 'Ammunition, camouflage clothing, optics, field accessories, backpacks.',
          },
        },
        {
          icon: '✓',
          title: { fr: 'Vérification PPA temps réel', en: 'Real-time PAL verification' },
          description: {
            fr: "Différenciateur unique : vérification automatique du permis PPA de l'acheteur via les services PCAF/GRC.",
            en: 'Unique differentiator: automatic buyer PAL verification via RCMP / Canadian Firearms Program services.',
          },
        },
      ]}
      cta={{
        label: ctaLabel,
        link: ctaLink,
      }}
      noteLegale={{
        fr: "Plateforme conforme à la Loi sur les armes à feu (Canada). Tous les transferts d'armes respectent les obligations PCAF/GRC en vigueur.",
        en: 'Platform compliant with the Firearms Act (Canada). All firearm transfers comply with current RCMP/PCAF obligations.',
      }}
    />
  );
}
